// extracted by mini-css-extract-plugin
export default {"container":"SearchClientEmployee_container__WDGLc","formItem":"SearchClientEmployee_formItem__7NqAO"};